<template>
  <div>
    <section-header heading="2" ja="「プリクラON」有料会員について"/>
    <div class="textArea">
      <p>
        有料会員になると、セガのプリクラ機で撮影した<br>
        全てのプリクラデータをダウンロードできます。
      </p>
      <p>
        ■無料会員：<br>
        1プレイにつき、<br>
        プリクラ2枚＋モーメント2枚をダウンロード可能<br>
        ※プリ機によってはモーメントが無い場合があります<br>
      </p>
      <p>
        ■有料会員：<br>
        撮影・選択した全てのデータをダウンロード可能<br>
      </p>
    </div>
    <section-header heading="2" ja="有料会員になるには"/>
    <div class="textArea">
      <template v-if="isIOS">
        <p>■iOSアプリの場合</p>
        <p>①サイドメニュー内「有料会員になる」を押すまたは「プロフィール・設定を変更する」の「会員状態」から「変更する」を押してください。</p>
        <div class="imgArea2">
          <div>
            <img src="@/assets/Png/Help/ios_tutorial01.jpg">
          </div>
          <div>
            <img src="@/assets/Png/Help/ios_tutorial02.jpg">
          </div>
        </div>
        <p>②有料会員サービスのプランを選択し、「有料会員になる」を押してください。</p>
        <div class="imgArea">
          <img src="@/assets/Png/Help/ios_tutorial03.jpg">
        </div>
        <p>
          ③有料会員登録の確認ダイアログにて、「YES」を押してください。<br>
          以降は、Apple側の決済画面にて、手続きを行ってください。
        </p>
        <div class="imgArea">
          <img src="@/assets/Png/Help/ios_tutorial04.jpg">
        </div>
      </template>
      <template v-else>
        <p>■Androidアプリの場合</p>
        <p>①サイドメニュー内「有料会員になる」を押すまたは「プロフィール・設定を変更する」の「会員状態」から「変更する」を押してください。</p>
         <div class="imgArea2">
          <div>
            <img src="@/assets/Png/Help/android_tutorial01.jpg">
          </div>
          <div>
            <img src="@/assets/Png/Help/android_tutorial02.jpg">
          </div>
        </div>
        <p>②有料会員サービスのプランを選択し、「有料会員になる」を押してください。</p>
        <div class="imgArea">
          <img src="@/assets/Png/Help/android_tutorial03.jpg">
        </div>
        <p>
          ③有料会員登録の確認ダイアログにて、「YES」を押してください。<br>
          以降は、Google側の決済画面にて、手続きを行ってください。
        </p>
        <div class="imgArea">
          <img src="@/assets/Png/Help/android_tutorial04.jpg">
        </div>
      </template>
    </div>
    <section-header heading="2" ja="有料会員のWEBとアプリの違い"/>
    <div class="textArea">
      <p>
        ■WEB決済<br>
        価格：月額330円(税込)<br>
        支払方法：以下から選択できます<br>
        ・d払い<br>
        ・auかんたん決済(au / UQ mobile)/au PAY<br>
        ・ソフトバンク・ワイモバイルまとめて支払い<br>
        ・クレジットカード<br>
        契約期間：月末まで<br>
        契約更新：毎月1日に更新<br>
        ※解約されるまで毎月自動更新されます<br>
        ※カード会社、キャリア合算の利用明細には「AimePay」「アイミーペイ」と記載されます。<br>
      </p>
      <p>
        ■アプリ内課金<br>
        価格：<br>
        <span class="textArea__text">月額プラン 450円(税込)</span><br>
        <span class="textArea__text">3ヵ月プラン 980円(税込)</span><br>
        <span class="textArea__text">12ヵ月プラン 3780円(税込)</span><br>
        支払い方法：お使いのアプリストア<br>
        契約期間：購入(自動更新)日からプランの対象期間が経過する日まで有効<br>
        契約更新：<br>
        <span class="textArea__text">月額プラン 1ヵ月毎に更新</span><br>
        <span class="textArea__text">3ヵ月プラン 3ヵ月毎に更新</span><br>
        <span class="textArea__text">12ヵ月プラン  12ヵ月毎に更新</span><br>
        <span class="textArea__text">※解約されるまで自動更新されます</span>
      </p>
    </div>
    <section-header heading="2" ja="有料会員を解約するには？"/>
    <div class="textArea">
      <p>
        <span class="textLink" @click="onAboutAppsubscription()">こちら</span>よりご確認ください
      </p>
    </div>
    <sub-btn @click="onAboutWeb()">プリクラONについてに戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'
import { isIOS } from "../assets/js/util"

export default {
  name: "AboutWeb10",
  components: {
    SectionHeader,
    SubBtn
  },
  data () {
    return { isIOS: null }
  },
  mounted() {
    this.isIOS = isIOS();
  },
  methods: {
    onAboutWeb() {
      this.$router.push("/AppaboutWeb")
    },
    onAboutAppsubscription() {
      this.$router.push('/AppAboutAppsubscription')
    },
    onPaidMemberRegistrationConsistency() {
      this.$router.push('/ApppaidMemberRegistrationConsistency')
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  &__text {
    margin-left: 12px;
  }
  p {
    margin-top: 1em;
  }
}
.imgArea {
  margin-top: 20px;
  text-align: center;
  img { width: 70%; }
}
.imgArea2 {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  img {
    width: 141px;
    height: auto;
  }
}
.textLink { color: #DA2240; }
</style>
